import React, { useState } from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { ColorRadioButton, RectangularRadioButton } from 'components/buttons/RadioButtons';
import RadioGroup from '@material-ui/core/RadioGroup';

const COLOR_OPTIONS = [
  '#FF0000',
  '#FF8900',
  '#FFEB00',
  '#50E600',
  '#059D3A',
  '#00C5DE',
  '#0158AF',
  '#5614D1',
  '#AD14D1',
  '#D1149E',
  '#000000'
];

const useStyles = makeStyles({
  radioGroup: {
    maxWidth: '170px',
    marginLeft: '25px'
  },
  formTitle: {
    textTransform: 'uppercase',
    fontWeight: '600',
    marginLeft: '-11px'
  },
  formButton: {
    marginLeft: '-12px',
    marginTop: '16px'
  }
});

const FormattingMenu = ({ handleClose }) => {
  const classes = useStyles();
  const [colorRadioValue, setColorRadioValue] = useState();

  const handleColorChange = event => {
    setColorRadioValue(event.target.value);
  };
  return (
    <form>
      <RadioGroup
        name="source"
        value={colorRadioValue}
        onChange={handleColorChange}
        className={classes.radioGroup}
      >
        <Typography variant="subtitle2" className={classes.formTitle} gutterBottom>
          Color Scheme
        </Typography>
        <Grid container direction="row" justify="flex-start" alignItems="flex-start">
          {COLOR_OPTIONS &&
            COLOR_OPTIONS.map(color => (
              <Grid item md="auto" key={color}>
                <ColorRadioButton value={color} />
              </Grid>
            ))}
          <Grid item xs={12} md={12} style={{ marginTop: '11px' }}>
            <RectangularRadioButton title="Use Default" value="#346C9F" />
          </Grid>
          <Grid item xs={5}>
            <Button variant="contained" color="primary" className={classes.formButton}>
              Save
            </Button>
          </Grid>
          <Grid item xs={5}>
            <Button color="primary" onClick={handleClose} className={classes.formButton}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </RadioGroup>
    </form>
  );
};

FormattingMenu.propTypes = {
  handleClose: PropTypes.func.isRequired
};

export default FormattingMenu;
